export default{
    trabalhador:{
        method:'get',
        url:'home/trabalhador'
    },
    aniversario:{
        method:'get',
        url:'home/aniversario'
    },
    tomador:{
        method:'get',
        url:'home/tomador'
    },
    listahistorico:{
        method:'get',
        url:'historico/lista'
    },
    cadastra:{
        method:'post',
        url:'comissionado/cadastro'
    },
    delete:{
        method:'delete',
        url:'comissionado/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'comissionado/editar{/id}'
    },
    update:{
        method:'post',
        url:'comissionado/update'
    }
}